import { Button, Modal, Tooltip } from "@alch/ui";
import { AudioSettings02 } from "@alch/ui/icons/16";
import useCurrentUser from "@queries/useCurrentUser";
import { IS_DEVELOPMENT } from "@util/deployEnv";
import { useBoolean } from "usehooks-ts";
import FlagsForm from "./FlagsForm";
import useFlagOverrides from "./useFlagOverrides";

const FlagOverrides = () => {
  const modalBool = useBoolean();
  const user = useCurrentUser();
  const { overrides } = useFlagOverrides();

  const isAlchemyUser =
    user.data?.is_staff ||
    user.data?.email.endsWith("@alchemy.com") ||
    user.data?.email.endsWith("@alchemyapi.com");

  if (!isAlchemyUser && !IS_DEVELOPMENT) return null;

  return (
    <>
      <div className="fixed bottom-3 left-3 z-40">
        <Tooltip
          content={
            <span>
              Feature Flag Overrides:{" "}
              <strong>{overrides ? "on" : "off"}</strong>
            </span>
          }
          withArrow
          theme="light"
        >
          <Button
            intent={overrides ? "destructive" : "secondary"}
            className="rounded-full border border-grayscale-200 shadow-xl"
            icon={<AudioSettings02 />}
            onClick={modalBool.setTrue}
          />
        </Tooltip>

        {overrides && (
          <div className="absolute right-0.5 top-0.5 size-2 rounded-full bg-critical-600" />
        )}
      </div>

      <Modal
        title="Feature Flag Overrides"
        isOpen={modalBool.value}
        onClose={modalBool.setFalse}
        className="mb-12 ml-0 max-w-96 p-0"
        headerClassName="px-4 pt-6 mb-4 pb-0.5"
      >
        <FlagsForm onSuccess={modalBool.setFalse} />
      </Modal>
    </>
  );
};

export default FlagOverrides;
